var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 7.58333L12.3804 9.6145C12.4243 9.64373 12.4754 9.66049 12.5281 9.66302C12.5808 9.66554 12.6331 9.65372 12.6797 9.62881C12.7262 9.60391 12.7651 9.56686 12.7922 9.52161C12.8193 9.47635 12.8336 9.42459 12.8337 9.37183V4.59083C12.8337 4.53951 12.8201 4.4891 12.7944 4.44468C12.7687 4.40026 12.7318 4.3634 12.6873 4.33784C12.6428 4.31228 12.5923 4.29891 12.541 4.29908C12.4897 4.29926 12.4393 4.31297 12.395 4.33883L9.33366 6.125M2.33366 3.5H8.16699C8.81132 3.5 9.33366 4.02233 9.33366 4.66667V9.33333C9.33366 9.97767 8.81132 10.5 8.16699 10.5H2.33366C1.68933 10.5 1.16699 9.97767 1.16699 9.33333V4.66667C1.16699 4.02233 1.68933 3.5 2.33366 3.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.32d6d527b27289dd1cbea1163ac9ab38.svg";
export { ForwardRef as ReactComponent };